import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ChangePasswordModal from './components/ChangePasswordModal';
import ChangeUsernameModal from './components/ChangeUsernameModal';
import styles from './ProfileAccount.module.css';

const ProfileAccount = () => {
  const navigate = useNavigate();
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [showChangeUsername, setShowChangeUsername] = useState(false);

  return (
    <div className={styles.accountPage}>
      <header className={styles.topBar}>
        <button
          type="button"
          className={styles.backButton}
          onClick={() => navigate('/profile')}
        >
          <span className={`material-symbols-outlined ${styles.backIcon}`}>arrow_back</span>
        </button>
        <div className={styles.pageTitle}>我的账户</div>
      </header>

      <div className={styles.menuList}>
        <button
          type="button"
          className={styles.menuItem}
          onClick={() => navigate('/profile/account/avatar')}
        >
          <div className={styles.menuContent}>
            <div className={styles.menuTitle}>上传头像</div>
            <div className={styles.menuDescription}>前往头像上传页面</div>
          </div>
          <div className={styles.menuArrow}>›</div>
        </button>

        <button
          type="button"
          className={styles.menuItem}
          onClick={() => setShowChangeUsername(true)}
        >
          <div className={styles.menuContent}>
            <div className={styles.menuTitle}>修改用户名</div>
            <div className={styles.menuDescription}>更改显示的用户名</div>
          </div>
          <div className={styles.menuArrow}>›</div>
        </button>

        <button
          type="button"
          className={styles.menuItem}
          onClick={() => setShowChangePassword(true)}
        >
          <div className={styles.menuContent}>
            <div className={styles.menuTitle}>修改密码</div>
            <div className={styles.menuDescription}>更新登录密码，保障账户安全</div>
          </div>
          <div className={styles.menuArrow}>›</div>
        </button>
      </div>

      <ChangeUsernameModal
        open={showChangeUsername}
        onClose={() => setShowChangeUsername(false)}
      />
      <ChangePasswordModal
        open={showChangePassword}
        onClose={() => setShowChangePassword(false)}
      />
    </div>
  );
};

export default ProfileAccount;
